module.exports = __webpack_public_path__ + "img/enterprise-dp.4fcc0e6e.png";